import { render, staticRenderFns } from "./SurveyResult.vue?vue&type=template&id=2ec76d44&scoped=true"
import script from "./SurveyResult.vue?vue&type=script&lang=js"
export * from "./SurveyResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec76d44",
  null
  
)

export default component.exports